import { render } from "./latest_archived_events.vue?vue&type=template&id=b38bd042"
import script from "./latest_archived_events.vue?vue&type=script&lang=js"
export * from "./latest_archived_events.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_0d900136/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__